import { Flex } from 'antd';
import { MapAssignmentModal } from './components/MapAssignmentModal/MapAssignmentModal';
import { ScheduleCreateModal } from './components/ScheduleCreateModal/ScheduleCreateModal';
import { ScheduleDeleteModal } from './components/ScheduleDeleteModal/ScheduleDeleteModal';
import { RobotSchedule } from './components/RobotSchedule/RobotSchedule';
import { ScheduleHeader } from './components/ScheduleHeader/ScheduleHeader';
import { ScheduleBanner } from './components/ScheduleBanner/ScheduleBanner';
import { MachineDetailsRobotScheduleProvider } from './context/MachineDetailsRobotScheduleContext';
import { kccThemeConstants } from 'config/theme/kccTheme/kccTheme';
import { Machine } from 'app/modules/machine-inventory/interfaces/Machine.types';
import { KCCThemeGlobalStyles } from 'config/theme/kccTheme/globalStyles';

export const MachineDetailsRobotSchedule = ({ robot }: { robot: Machine }): JSX.Element => (
  <MachineDetailsRobotScheduleProvider robot={robot}>
    <KCCThemeGlobalStyles />

    <Flex vertical gap={kccThemeConstants.SPACING.LG} style={{ height: '100%' }}>
      <ScheduleBanner />
      <ScheduleHeader />
      <RobotSchedule />
    </Flex>

    <ScheduleCreateModal />
    <ScheduleDeleteModal />
    <MapAssignmentModal />
  </MachineDetailsRobotScheduleProvider>
);
